import axios from "axios";
import { 
    GET_LEAD_FORM_FAIL, GET_LEAD_FORM_SUCCESS, GET_LEAD_FORM_REQUEST, 
    LEAD_FORM_SUBMIT_FAIL, LEAD_FORM_SUBMIT_REQUEST, LEAD_FORM_SUBMIT_SUCCESS, 
    IS_FORM_SUBMITTED_TO_ELOQUA_REQUEST, IS_FORM_SUBMITTED_TO_ELOQUA_SUCEESS, IS_FORM_SUBMITTED_TO_ELOQUA_FAIL,
    PUBLISH_REQUEST, PUBLISH_SUCCESS,PUBLISH_FAIL 
} from "../constant";
import { clearAllFields } from "./surveyFieldDataAction";

export const getLeadFormData = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: GET_LEAD_FORM_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/getLeadForm`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                localStorage.setItem("customer_token", res?.data?.token)
                dispatch({ type: GET_LEAD_FORM_SUCCESS, payload: res?.data?.data });
                if (res?.data?.data?.length === 0) {
                    navigate('/')
                }
            })
            .catch(err => {
                console.error("GET FORM DATA FAIL", err)
                dispatch({ type: GET_LEAD_FORM_FAIL });
            })
    }
}

// export const submitLeadFormData = (data, navigate) => {
//     return async (dispatch) => {
//         dispatch({ type: LEAD_FORM_SUBMIT_REQUEST });
//         let token = localStorage.getItem("customer_token")
//         let options = {
//             method: 'POST',
//             url: `${process.env.REACT_APP_API_URL}/frnt/submitLead`,
//             headers: {
//                 'Accept': 'application/json',
//                 'Authorization': `Bearer ${token}`
//             },
//             data: data
//         };
//         await axios(options)
//             .then(res => {
//                 localStorage.setItem("customer_token", res?.data?.token)
//                 dispatch({ type: LEAD_FORM_SUBMIT_SUCCESS, payload: res?.data?.ss_id });
//                 dispatch(clearAllFields())
//                 if(data.emailVerification === false){
//                     navigate(`/qna/${data.survey_id}/${res?.data?.ss_id}`);
//                 }
//                 return res;
//             })
//             .catch(err => {
//                 console.error("FORM DATA FAIL", err)
//                 dispatch({ type: LEAD_FORM_SUBMIT_FAIL });
//             })
//     }
// }
export const submitLeadFormData = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: LEAD_FORM_SUBMIT_REQUEST });
        const token = localStorage.getItem("customer_token");
        const options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/submitLead`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };

        try {
            const res = await axios(options);
            localStorage.setItem("customer_token", res?.data?.token);
            dispatch({ type: LEAD_FORM_SUBMIT_SUCCESS, payload: res?.data?.ss_id });
            dispatch(clearAllFields());
            if (data.emailVerification === false || data.emailValidationTiming === 'after') {
                navigate(`/qna/${data.survey_id}/${res?.data?.ss_id}`);
            }
            return res?.data; // Ensure this is returned
        } catch (err) {
            console.error("FORM DATA FAIL", err);
            dispatch({ type: LEAD_FORM_SUBMIT_FAIL });
            throw err; // Rethrow error for further handling
        }
    }
}
export const checkPublish = (data, navigate) => {
    return async (dispatch) => {
        dispatch({ type: PUBLISH_REQUEST });
        let token = localStorage.getItem("customer_token")
        let options = {
            method: 'POST',
            url: `${process.env.REACT_APP_API_URL}/frnt/checkPublish`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: data
        };
        await axios(options)
            .then(res => {
                localStorage.setItem("customer_token", res?.data?.token)
                localStorage.setItem("su_is_landing_page", res.data.data[0].su_is_landing_page)
                dispatch({ type: PUBLISH_SUCCESS, payload: res?.data?.data });
                if (res?.data?.data?.length === 0) {
                    navigate('/')
                }
            })
            .catch(err => {
                console.error("PUBLISH FAIL", err)
                dispatch({ type: PUBLISH_FAIL });
            })
    }
}

export const sendEmailVefifyOtp = (data) => {
    console.log(data)
}

// export const resendEmailVerifyOtp = (data, callBack) => {
//     return async (dispatch) => {
//         dispatch({ type: RESEND_OTP_REQUEST });
//         const { response, error } = await apiRequest({
//             method: 'POST',
//             url: `/users/resend-otp`,
//             data: data
//         })
//         if (response) {
//             if (response.data.statusCode === 200) {
//                 dispatch({ type: RESEND_OTP_SUCCESS })
//                 callBack();
//             } else {
//                 console.log("Unable to RESEND OTP");
//             }
//         }
//         else if (error) {
//             dispatch({ type: RESEND_OTP_FAIL })
//         }
//     }
// }
// return async (dispatch) => {
    //     dispatch({ type: VERIFY_OTP_REQUEST });
    //     const { response, error } = await apiRequest({
    //         method: 'POST',
    //         url: `/users/verify-otp`,
    //         data: data
    //     })
    //     if (response) {
    //         if (response.data.statusCode === 200) {
    //             dispatch({ type: VERIFY_OTP_SUCCESS })
    //             localStorage.setItem('token_id', data.token);
    //             // window.location = '/admin/survey/list';
    //             dispatch({ type: LOGIN_SUCCESS })
    //             callBack();
    //         } else {
    //             console.log("Unable to Verify");
    //             dispatch({ type: VERIFY_OTP_FAIL })
    //         }
    //     }
    //     else if (error) {
    //         toast.error("Invalid OTP!");
    //         dispatch({ type: VERIFY_OTP_FAIL })
    //     }
    // }